module.exports = __webpack_public_path__ + "img/매칭정보획득아이콘.843accd6.png";